import { AddnewTabFunction } from "../Requests/mutators";
import React, { useState, useEffect } from "react";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import TextField from "@material-ui/core/TextField";
import URLconfig from "../Util/URLConfig";
import { useForm } from "react-hook-form";
const AddnewTab = () => {
  const [isLoading, setisLoading] = React.useState(true);
  const [required, setrequired] = React.useState(false);
  const [addtabData, setAddData] = React.useState({
    tabId: 0,
    tabName: "",
    isAvaliable: -1,
  });

  const onSubmit = async () => {
    try {
      setisLoading(true);
      await AddnewTabFunction(addtabData);
      setisLoading(false);
      alert("Addition Occured Successfully");
      setrequired(false);
      // window.location.href = "/#/dashboard";
      // window.location.href = `${URLconfig.BASE_URL}Policies/#/dashboard`;
      //window.location.href = `http://localhost:3000/#/dashboard`;
    } catch (err) {
      setisLoading(false);
      alert("Error while Adding user details, Please Try Again");
    }
  };
  useEffect(() => {
    setisLoading(false);
  }, []);

  return (
    <div>
      <div class="row d-flex justify-content-center align-items-center h-100">
        <div class="col-lg-8 col-xl-6">
          <div class="card rounded-3">
            <div class="card-body p-4 p-md-5">
              <h3 class="mb-4 pb-2 pb-md-0 mb-md-5 px-md-2 ButtonFrame">
                Add Tab Panel
              </h3>
              <ValidatorForm onSubmit={onSubmit} class="px-md-2">
                <div class="form-outline w-100 mb-4">
                  <TextValidator
                    type="text"
                    id="form3Example1q"
                    className="w-100"
                    value={addtabData.tabName}
                    onChange={(e) => {
                      setAddData({
                        ...addtabData,
                        tabName: e.target.value,
                      });
                    }}
                    required
                    validators={["required"]}
                    errorMessages={["this field is required"]}
                    name="tabName"
                    label="Tab Name"
                  />
                </div>
                <div class="form-outline mb-4">
                  <select
                    required
                    class="form-select"
                    value={addtabData.isAvaliable}
                    onChange={(e) => {
                      setAddData({
                        ...addtabData,
                        isAvaliable: Number(e.target.value),
                      });
                    }}
                    name="isAvaliable"
                  >
                    <option value="">Select Activity</option>
                    <option value="1">Active</option>
                    <option value="0">Not Active</option>
                  </select>
                </div>
                <button
                  type="submit"
                  class="btn btn-success col-3"
                  //onClick={() => onSubmit()}
                  disabled={isLoading}
                >
                  {isLoading == true ? "Adding Tab..." : "Add Tab"}
                </button>
              </ValidatorForm>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddnewTab;
